import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconWellOrangeSizeS from './IconWellOrange_size_s';

const props: CreateIconArguments = {
  l: IconWellOrangeSizeS,
  m: IconWellOrangeSizeS,
  s: IconWellOrangeSizeS,
  xs: IconWellOrangeSizeS,
  name: 'IconWellOrange',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
